export default "__VITE_ASSET__BAwvaYoL__"